<header>
  <div class="grid">
    <div class="col-3">
      <div class="logo">
        <img src="assets/images/logo.png" alt="" />
      </div>
    </div>

    <div class="col-4 search">
      <products-search></products-search>
    </div>

    <div class="col-3 col-offset-1 navigation">
      <ngshop-nav></ngshop-nav>
    </div>
    <div class="col-1 tools">
      <!-- <i class="pi pi-user p-text-secondary" style="font-size: 1.3rem"></i> -->
      <a routerLink="/login"
        ><i class="pi pi-user p-text-secondary" style="font-size: 1.3rem"></i
      ></a>
      <orders-cart-icon></orders-cart-icon>
    </div>
  </div>
</header>
